// Imports
import React from 'react';
import Heading from '../../shareables/foundation/admin-ui/components/content/heading';
import Box from '../../shareables/foundation/admin-ui/components/content/box';
import ButtonGroup from '../../shareables/foundation/front-end/components/buttons/group';
import AnchorButton from '../../shareables/foundation/front-end/components/buttons/anchor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUp, faListCheck } from '@fortawesome/pro-regular-svg-icons';
import LinkButton from '../../shareables/foundation/front-end/components/buttons/link';
import planNameMapping from '../../shareables/utils/billing/plan-name-mapping';
import planMapping from '../../shareables/utils/billing/plan-mapping';


// Define the accepted props
interface Props {
	description: string;
	requiredPlan?: number;
	plural?: boolean;
}


// Function component
const UpgradePage: React.FC<Props> = ({ description, requiredPlan, plural }) => {
	// Return JSX
	return (
		<React.Fragment>
			<Heading size={1}>Upgrade to unlock!</Heading>
			
			<Box>
				<p>
					{description} {plural ? 'are some' : 'is one'} of many great features on our{' '}
					<strong>{planNameMapping[requiredPlan ?? planMapping.engage]} plan</strong>!
				</p>
				
				<ButtonGroup>
					<LinkButton to='/settings/billing'>
						<FontAwesomeIcon icon={faCircleUp} />
						<span>Upgrade</span>
					</LinkButton>
					
					<AnchorButton
						href={`https://www.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}/pricing`}
						color='plain'
						border
						target='_blank'
					>
						<FontAwesomeIcon icon={faListCheck} />
						<span>Compare features</span>
					</AnchorButton>
				</ButtonGroup>
			</Box>
		</React.Fragment>
	);
};

export default UpgradePage;
